export default "<figure class=\"flux-image\">\n  <img src=\"\" alt=\"\" class=\"img-fluid\">\n  <figcaption></figcaption>\n</figure>\n"